import { render, staticRenderFns } from "./LanguageSettings.vue?vue&type=template&id=61a51678&scoped=true&lang=pug"
import script from "./LanguageSettings.vue?vue&type=script&lang=js"
export * from "./LanguageSettings.vue?vue&type=script&lang=js"
import style0 from "./LanguageSettings.vue?vue&type=style&index=0&id=61a51678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a51678",
  null
  
)

export default component.exports